import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ModalService {
  private _visibilityChanged = new Subject<boolean>();

  visibilityChanged$ = this._visibilityChanged.asObservable();

  setVisibility(visible: boolean) {
    this._visibilityChanged.next(visible);
  }
}
